/*
  最近閲覧した商品（recently viewed）。
  - product ページで現在の商品 ID を localStorage に記録（新しい順・重複排除・上限20）。
  - 自分以外の履歴 ID から Search API（id: フィルタ）でこのセクションを再取得し、カードを差し込む。
  - 履歴が無い／取得失敗時は要素を隠す（グレースフル）。
  Dawn の card-product / related-products スタイルを流用＝見た目は custom.css。
*/
class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const key = 'kunisawa:recently-viewed';
    const currentId = this.dataset.productId;
    const limit = parseInt(this.dataset.productsToShow, 10) || 4;

    let history = [];
    try {
      history = JSON.parse(localStorage.getItem(key)) || [];
    } catch (e) {
      history = [];
    }
    if (!Array.isArray(history)) history = [];

    // 表示対象＝現在の商品を除いた履歴（新しい順）
    const ids = history.filter((id) => id && String(id) !== String(currentId)).slice(0, limit);

    // 現在の商品を履歴の先頭に記録（次ページ以降のために）
    if (currentId) {
      const next = [String(currentId)]
        .concat(history.map(String).filter((id) => id !== String(currentId)))
        .slice(0, 20);
      try {
        localStorage.setItem(key, JSON.stringify(next));
      } catch (e) {
        /* localStorage 不可（プライベートブラウズ等）は無視 */
      }
    }

    if (!ids.length) {
      this.hidden = true;
      return;
    }

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = `${this.dataset.searchUrl}?q=${encodeURIComponent(query)}&type=product&section_id=${this.dataset.sectionId}`;

    fetch(url)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const incoming = html.querySelector('recently-viewed-products');
        const grid = incoming && incoming.querySelector('.grid');
        if (grid) {
          // Search API は relevance 順で返り、要求した id 順を保証しない。
          // 履歴の新しい順（ids）にカードを並べ替えてから差し込む（data-product-id で対応付け）。
          const order = new Map(ids.map((id, i) => [String(id), i]));
          Array.from(grid.querySelectorAll('.grid__item'))
            .sort((a, b) => (order.get(a.dataset.productId) ?? Infinity) - (order.get(b.dataset.productId) ?? Infinity))
            .forEach((li) => grid.appendChild(li));
          this.innerHTML = incoming.innerHTML;
        } else {
          this.hidden = true;
        }
      })
      .catch((error) => {
        // 取得失敗（ネットワーク/HTTP/パース）はセクションを隠してグレースフルに継続するが、
        // 握り潰さず開発コンソールには残す（真の不具合が見えなくなるのを防ぐ）。
        console.warn('[recently-viewed] 最近閲覧した商品の取得に失敗したため非表示にします', error);
        this.hidden = true;
      });
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
